export enum CustomFieldBooleanValues {
  No,
  Yes,
}
